import styled from 'styled-components';
import { DatePicker, Form, InputNumber, Radio, Row } from 'antd';
import { LABEL_MEDIUM_SEMIBOLD } from '@/components/Settings/DataExtraction/styles';

const { RangePicker } = DatePicker;

export const CustomInputContainer = styled.div`
	.ant-input {
		border-radius: 4px !important;
	}
`;

export const CustomDatePicker = styled(RangePicker)`
	width: 100%;
	border-radius: 4px !important;

	.ant-picker-input > input {
		border-radius: 4px !important;
	}
`;

export const RadioWrapper = styled(Radio)`
	font-size: 0.79rem;
`;

export const InputNumberWrapper = styled(InputNumber)`
	width: 100%;
`;

export const CustomFormItem = styled(Form.Item)`
	margin-bottom: 0 !important;

	.ant-form-item-label label,
	.ant-form-item-label > label {
		${LABEL_MEDIUM_SEMIBOLD}
		height: 100% !important;
	}
`;

export const CustomRow = styled(Row)`
	align-items: flex-end;
`;
